import Tag from 'atoms/Tag/Tag';

const Tags: React.FC<{ children: any }> = (props: any) => {
  const tags: string[] =
    typeof props.children === 'string'
      ? props.children.split(',')
      : props.children.props.children.split(',');

  return (
    <div className="flex flex-wrap gap-16">
      {tags.map((tag, i) => (
        <Tag key={i} size="large">
          {tag.trim()}
        </Tag>
      ))}
    </div>
  );
};

export default Tags;
